import { useState, useEffect } from 'react';

function Carousel({ slides }) {
  const [index, setIndex] = useState(0);
  const count = slides.length;

  useEffect(() => {
    if (count <= 1) return;
    const t = setInterval(() => {
      setIndex(i => (i + 1) % count);
    }, 5000);
    return () => clearInterval(t);
  }, [count]);

  if (!slides || slides.length === 0) return null;

  const go = (i) => {
    setIndex(((index + i) % count + count) % count);
  };

  return (
    <section className="home-carousel">
      <div className="home-carousel__track" style={{ transform: `translateX(-${index * 100}%)` }}>
        {slides.map((slide) => (
          <div key={slide.id} className="home-carousel__slide">
            <img src={slide.image_url} alt={slide.caption || ''} />
            {slide.caption && (
              <div className="home-carousel__caption">{slide.caption}</div>
            )}
          </div>
        ))}
      </div>
      {count > 1 && (
        <>
          <button type="button" className="home-carousel__prev" onClick={() => go(-1)} aria-label="Previous">
            ‹
          </button>
          <button type="button" className="home-carousel__next" onClick={() => go(1)} aria-label="Next">
            ›
          </button>
          <div className="home-carousel__dots">
            {slides.map((_, i) => (
              <button
                key={i}
                type="button"
                className={`home-carousel__dot ${i === index ? 'active' : ''}`}
                onClick={() => setIndex(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
}

export default Carousel;
